import React from "react";
import MyGoalCard from "../MyGoalCard/MyGoalCard";
import Actions from "../../../../../../../Shared/Actions/Actions";
import Swal from "sweetalert2";
import Sidebar from "../../../../../../../CommonComponets/SideBar";
import FloatingTextarea from "../../../../../../../Shared/FloatingTextArea/FloatingTextArea";
import DateInput from "../../../../../../../Shared/DateBox";
import InputBox from "../../../../../../../Shared/InputBox";

const TeamTarget = () => {
  const [open, setOpen] = React.useState(false);
  const handleEdit = () => {
    setOpen(true);
    console.log("Edit clicked", 1);
  };

  const handleDelete = () => {
    Swal.fire({
      title: "",
      html: `
          <div style="text-align:center;">
            <div style="
              width:80px;
              height:80px;
              border-radius:50%;
              background:#ca2a2a60;
              display:flex;
              align-items:center;
              justify-content:center;
              margin:0 auto 15px;
            ">
              <i>
               <svg width="50" height="50" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" fill="#ff3434" />
        <path
        fill="none"
          d="M7 12l3 3 7-7"
          stroke="#fff"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
              </i>
            </div>
            <h4 style="color:#333; margin-bottom:10px;">Remove Goal?</h4>
            <p style="font-size:16px; color:#555;">
              Are you sure you want to remove
    goal you selected.
            
            </p>
          </div>
        `,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it",
      cancelButtonText: "Cancel",

      // Colors
      confirmButtonColor: "#ff3434",
      cancelButtonColor: "#e0e0e0",

      // Remove default icon
      icon: undefined,

      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "custom-confirm-btn",
        cancelButton: "custom-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Status Changed!");
      }
    });
  };

  const handleStatusChange = () => {
    Swal.fire({
      title: "",
      html: `
          <div style="text-align:center;">
            <div style="
              width:80px;
              height:80px;
              border-radius:50%;
              background:#e6f4ea;
              display:flex;
              align-items:center;
              justify-content:center;
              margin:0 auto 15px;
            ">
              <i>
               <svg width="50" height="50" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="10" fill="#4CAF50" />
        <path
        fill="none"
          d="M7 12l3 3 7-7"
          stroke="#fff"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
              </i>
            </div>
    
            <p style="font-size:16px; color:#555;">
              Do you want to change goal status into 
              <span style="color:#E41F07; font-weight:600;">Incomplete</span>.
            </p>
          </div>
        `,
      showCancelButton: true,
      confirmButtonText: "Yes, Change it",
      cancelButtonText: "Cancel",

      // Colors
      confirmButtonColor: "#4caf50",
      cancelButtonColor: "#e0e0e0",

      // Remove default icon
      icon: undefined,

      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "custom-confirm-btn",
        cancelButton: "custom-cancel-btn",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Status Changed!");
      }
    });
  };
  const [addOpen, setAddOpen] = React.useState(false);
  const HandlerAddTeamTarget = () => {
    setAddOpen(true);
  };
  return (
    <>
      <MyGoalCard
        handleClick={HandlerAddTeamTarget}
        title={"Team Target"}
        action={"Add Team Target"}
      >
        <div className="card-body p-3">
          <div className="card mb-3">
            <div className="card-body" id="dvProfssnlGlList">
              <div className="d-sm-flex align-items-center justify-content-between pb-2">
                {/* Date Section */}
                <div className="d-flex align-items-center mb-2">
                  <p className="fw-bold">
                    <strong className="text-dark fs-8">
                      Date : 31-10-2024
                    </strong>
                  </p>
                </div>

                {/* Status + Dropdown */}
                <div className="d-flex  justify-content-between column-gap-4 align-items-center ">
                  <span className="text-success">Complete</span>
                  <div className="position-relative d-flex justify-content-center align-items-center">
                    <Actions
                      sty={{ position: "absolute", right: "34px", top: "33px" }}
                      handleDelete={handleDelete}
                      handleEdit={handleEdit}
                      handleStatusChange={handleStatusChange}
                      third="Incomplete"
                      txtcolor="text-danger"
                    />
                  </div>
                </div>
              </div>

              {/* Content */}
              <p>Amount : 59999.00</p>

              <ul style={{ listStyleType: "square" }}>
                <li>Lorem Ipsum has been the industry's standard</li>
                <li>dummy text ever since the 1500s</li>
                <li>
                  when an unknown printer took a galley of type and scrambled
                </li>
              </ul>
            </div>
          </div>
        </div>
      </MyGoalCard>
      {(open || addOpen) && (
        <Sidebar
          minWidth={"500px"}
          setIsFilter={() => {
            (setOpen(false), setAddOpen(false));
          }}
          heading={`${addOpen ? "Add" : "Update"} Team Target`}
          title={`${addOpen ? "Add" : "Update"} Team Target`}
          onClose={() => {
            (setOpen(false), setAddOpen(false));
          }}
        >
          <div className="col-12 my-3">
            <FloatingTextarea
              label="Description"
              required={true}
              placeholder="update your description here..."
              rows={5}
            />
          </div>
          <div className="col-12 my-2">
            <DateInput label="Date" required={true} />
          </div>
          <div className="col-12 my-2">
            <InputBox
              placeholder={"Update  Amount here..."}
              type={"number"}
              label="Amount"
              required={true}
            />
          </div>
          <div className="d-flex my-4">
            <button
              className="btn w-50 btn-outline-secondary me-2"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
            <button className="btn w-50 btn-outline-success">
              Save Changes
            </button>
          </div>
        </Sidebar>
      )}
    </>
  );
};

export default TeamTarget;
